// extracted by mini-css-extract-plugin
export default {"outerwrap":"OutputControls_outerwrap__JD0ni","loader-wrap":"OutputControls_loader-wrap__2IBId"};